import { TokenType } from 'src/common/types/models/Tokens'
import { BigSource } from 'big.js'
import { useCallback } from 'react'
import { PreparedTransaction } from 'thirdweb'
import { setApprovalForAll as approveERC1155 } from 'thirdweb/extensions/erc1155'
import { approve as approveERC20 } from 'thirdweb/extensions/erc20'
import { setApprovalForAll as approveERC721 } from 'thirdweb/extensions/erc721'
import useGetContract from '../common/useGetContract'

type ApproveParams = {
  spender: string | undefined
  tokenAddress: string | undefined
  tokenType: TokenType | undefined
  amount: BigSource | undefined
}

const useApproveToken = () => {
  const { getContract } = useGetContract()

  const approveToken = useCallback(
    ({ tokenAddress, tokenType, spender = '', amount }: ApproveParams) => {
      if (!tokenAddress || !tokenType) return
      const contract = getContract(tokenAddress)
      if (!contract) return

      let tx: PreparedTransaction | undefined

      if (tokenType === 'ERC20') {
        tx = approveERC20({
          contract,
          spender,
          amount: amount?.toString() || Number.MAX_SAFE_INTEGER,
        })
      } else if (tokenType === 'ERC721') {
        tx = approveERC721({ contract, operator: spender, approved: true })
      } else if (tokenType === 'ERC1155') {
        tx = approveERC1155({ contract, operator: spender, approved: true })
      }

      return tx
    },
    [getContract]
  )

  return approveToken
}

export default useApproveToken
